<template>
  <div
    class="vx-card crew-assignment-card"
    :class="{
      'crew-assignment-card-normal': !hasError && !hasWarning,
      'crew-assignment-card-alert': hasError,
      'crew-assignment-card-warning': hasWarning,
    }"
  >
    <div class="vx-card-header">
      <span class="vx-card-title">{{ name }}</span>
      <feather-icon
        v-if="hasError"
        class="crew-assignment-icon"
        svgClasses="crew-assignment-icon-alert"
        icon="InfoIcon"
      />
      <feather-icon
        v-if="hasWarning"
        class="crew-assignment-icon"
        svgClasses="crew-assignment-icon-warning"
        icon="AlertCircleIcon"
      />
    </div>
    <div class="vx-card-body">
      <div class="crew-assignment-name">
        {{ role }}
      </div>
      <div class="crew-assignment-status">
        <span class="crew-assignment-info">{{ info }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CrewAssignmentCard",
  props: {
    crew: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    hasWarning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    info() {
      const date = new Date(this.crew.start_at);
      const options = { month: "numeric", day: "numeric" };
      const formatted = date.toLocaleDateString("ja-JP", options);
      return `下船中 (${formatted}〜休暇${this.days_off_while_ashore}日間)`;
    },
    name() {
      return this.crew.crew.name;
    },
    days_off_while_ashore() {
      return this.crew.days_off_while_ashore;
    },
  },
};
</script>

<style lang="scss" scoped>
.crew-assignment-card-normal {
  background-color: #f6f7f9;
}
.crew-assignment-card-alert {
  background-color: #fbeded;
}
.crew-assignment-card-warning {
  background-color: #fff8e4;
}
.crew-assignment-card {
  width: 150px;
  padding: 6px 10px 6px 10px;
  border-radius: 2px;
  .vx-card-header {
    position: relative;
    .vx-card-title {
      font-size: 14px;
      line-height: 16px;
    }
    .crew-assignment-icon {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .crew-assignment-icon-alert {
      color: #e02e22;
    }
    .crew-assignment-icon-warning {
      color: #ffd400;
    }
  }
  .vx-card-body {
    .crew-assignment-name {
      font-size: 12px;
      line-height: 16px;
      margin-top: 2px;
    }
    .crew-assignment-status {
      font-size: 10px;
      margin-top: 2px;
      line-height: 12px;
      display: flex;
      .crew-assignment-status-item {
        flex: 1;
      }
      .crew-assignment-info {
        flex: 1;
      }
      .crew-assignment-until {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
